import { FiltersDefinition } from "../../../../../../types/registers/search/filter/filtersDefinition";

export const DECISION_FILTERS: FiltersDefinition = {
  documentDate: {
    id: "documentDate",
    label: "l.searchFilter.decisionDate",
  },
  objectType: {
    id: "objectType",
    label: "l.searchFilter.decisionObjectType",
  },
  legalGroundTypes: {
    id: "legalGroundTypes",
    label: "l.searchFilter.decisionGroundType",
  },
  documentType: {
    id: "documentType",
    label: "l.searchFilter.decisionType",
  },
  objectId: {
    id: "objectId",
    label: "l.searchFilter.decisionObjectId",
  },
  documentNumber: {
    id: "documentNumber",
    label: "l.searchFilter.decisionDocumentNumber",
  },
};
